require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var digest = require('./digest');

var parseData = require('./parse-data');

var parseNode = function parseNode(email) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var data = parseData(email, query);
  return _objectSpread(_objectSpread({}, data), {}, {
    // Required fields.
    id: "gravatar-".concat(data.hash, "-").concat(digest(data.query || '')),
    parent: null,
    children: [],
    internal: {
      type: "gravatar",
      contentDigest: digest(JSON.stringify(data)),
      description: "Gravatar URL for email \"".concat(data.email, "\" with ").concat(data.query ? 'query "' + data.query + '"' : 'no queries', ".") // Optional.

    }
  });
};

module.exports = parseNode;